<template>
	<div v-if="headingImage" :class="{ subpage: !route.name.startsWith('index') }" style="position: relative">
		<div class="hero-image">
			<div class="hero-image-border fade-animate" />
			<div v-if="headingImage.title" class="hero-content">
				<div class="row">
					<div class="columns column12">
						<h1 class="hero-title">
							{{ headingImage.title }}
						</h1>
						<span class="hero-subtitle">
							{{ headingImage.subtitle }}
						</span>
					</div>
				</div>
			</div>

			<picture>
				<source
					v-if="headingImage.imagePortraitWebp"
					:srcset="headingImage.imagePortraitWebp"
					type="image/webp"
					media="(max-width: 500px)"
				/>
				<source
					v-if="headingImage.imagePortrait"
					:srcset="headingImage.imagePortrait"
					media="(max-width: 500px)"
				/>
				<source :srcset="headingImage.imageWebp" type="image/webp" />
				<source :srcset="headingImage.image" />
				<img class="slider-image" :src="headingImage.image" :alt="headingImage.imageAlt" />
			</picture>
		</div>

		<slot name="bookingForm" />
	</div>
</template>

<script setup>
const route = useRoute();

defineProps({
	headingImage: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.hero-image {
	width: 100%;
	height: calc(100vh - 50px);
	position: relative;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: all 0.3s ease-in-out;
		animation:
			zoom-in 9000ms ease-in-out forwards,
			fade-in 800ms ease-out;
	}

	&::before {
		content: '';
		z-index: 2;
		position: absolute;
		display: block;
		inset: 0;
		background: linear-gradient(180deg, rgb(20 57 49 / 70%) 0%, rgb(20 57 49 / 0%) 100%);
	}
}

.hero-image-border {
	width: 2px;
	background: #fff;
	position: absolute;
	inset: 24% auto 76% calc(50vw - 680px);
	z-index: 5;

	&.active {
		inset: 24% auto 36% calc(50vw - 680px);
	}
}

.hero-content {
	position: absolute;
	inset: auto 0 150px;
	z-index: 3;
	padding: 0 20px;
	color: #fff;
	animation: fade-from-bottom 1.4s ease;

	span,
	h1 {
		color: #fff;
		font-weight: 400;
		font-size: 48px;
		letter-spacing: 1px;
		width: 100%;
		font-family: var(--heading-font-family);
		display: inline-block;
		margin: 0 0 3px;
	}

	.hero-subtitle {
		font-weight: 200;
	}
}

@keyframes zoom-in {
	0% {
		transform: scale(1);
	}

	100% {
		transform: scale(1.08);
	}
}

@media (max-width: 1460px) {
	.hero-content {
		padding: 0;
		inset: auto 0 180px;
	}

	.hero-image-border {
		inset: 24% auto 76% 40px;

		&.active {
			inset: 24% auto 36% 40px;
		}
	}
}

@media (max-width: 880px) {
	.hero-content {
		h1,
		span {
			font-size: 34px;
		}

		.hero-subtitle {
			font-weight: 300;
		}
	}

	.hero-image-border {
		inset: 24% auto 76% 27px;

		&.active {
			inset: 20% auto 42% 27px;
		}
	}
}

@media (max-width: 680px) {
	.hero-content {
		h1,
		span {
			font-size: 28px;
		}
	}
}

@media (max-width: 400px) {
	.hero-content {
		h1,
		span {
			font-size: 20px;
			line-height: 24px;
		}
	}
}

@media (max-height: 440px) {
	.hero-image-border.active {
		inset: 24% auto 46% 40px;
	}
}
</style>
